export default __webpack_public_path__ + "static/media/02.d58136ff.jpg";